<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white bg-dark">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Benvenuto nel CRM CEDASCOM. Effettua l'accesso per proseguire.</p>
                                </div>
                                <p style="color:red">{{this.error}}</p>
                                <vs-input
                                    name="email"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="Email"
                                    v-model="email"
                                    class="w-full no-icon-border"/>

                                <vs-input
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="Password"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border"
                                    v-on:keyup.13="login" />

                                <div class="flex flex-wrap justify-between my-5">
                                  <vs-button  to="/pages/forgot-password" color="primary" type="flat">Password dimenticata?</vs-button>
                                </div>
                                <vs-button @click="login" class="m-4 float-right">Login</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            email: '',
            password: '',
            error: '',
            // checkbox_remember_me: false
        }
    },
    methods: {
      login() {
        axios.post(process.env.VUE_APP_BACKEND_API+'/auth/login', {
          email: this.email,
          password: this.password
        }, {
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
        }).then(response => {
          // console.log(response,this.$cookies)
          if (response.data.pw_reset) {
            this.$router.push({ name: 'pageResetPassword', params: { id: response.data.id } })
          } else {
            if (response.data.mailed) {
              this.openNotification('top-right','warning', 'Cambio Password', `Sono passati 6 Mesi dall'ultimo cambio di password è necessario impostarne una nuova, notificato anche per email`)
            }
            this.$router.push(this.$route.query.to || '/' )
          }
        })
        .catch(() => this.error = 'Email e/o Password errati')
      },
      openNotification(position = null, color, title, text) {
        this.$vs.notify({
          time: 8000,
          color,
          position,
          title,
          text,
        })
      },
  }
}
</script>
